/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Aborted_BodyInputs */



/**
* | output |
* | --- |
* | "You ended the conversation before anything was said, so there is nothing to give feedback on. Start a new practice conversation whenever you are ready." |
*
* @param {Practice_Session_Aborted_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_aborted_body = /** @type {((inputs?: Practice_Session_Aborted_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Aborted_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je hebt het gesprek beëindigd voor er iets gezegd is, dus er is niets om feedback op te geven. Start een nieuw oefengesprek wanneer je klaar bent om te oefenen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez terminé l'entretien avant que quoi que ce soit ne soit dit, il n'y a donc rien à commenter. Lancez un nouvel entretien d'entraînement dès que vous êtes prêt·e.")
	return /** @type {LocalizedString} */ ("You ended the conversation before anything was said, so there is nothing to give feedback on. Start a new practice conversation whenever you are ready.")
});